export default {
    signIn_enter: "Увійдіть, використовуючи",
    signIn_or: "або",
    signIn_difficulties: "Маєте труднощі?",
    signIn_contact: "Звертайтесь до нас за адресою",
    signIn_signIn_title: "Вхід",
    signIn_signUp_title: "Реєстрація",
    signIn_enter_using_email: "або увійдіть, використовуючи email",
    signIn_email_hint: "Email",
    signIn_password_hint: "Пароль",
    signIn_signInBtn: "Увійти",
    signIn_forgotPass_btn: "Забули пароль?",
    signIn_noCreditReq: "Платіжні дані не потрібні",
    signIn_firstName_hint: "Ім\'я",
    signIn_lastName_hint: "Прізвище",
    signIn_signUp_btn: "Створити акаунт",
    signIn_useMedia: "Або зарєструйтеся через соцмережі",
    signIn_agreeTo: "Я приймаю",
    signIn_tAndC: "Умови використання",
    signIn_recoverPassword: "Відновлення пароля",
    signIn_recoverPassSubtitle: "Введіть email, який було використано при реєстрації",
    signIn_recoverPassContinue: "Продовжити",
    signIn_recoverPassBack: "На сторінку входу",
    signIn_protected: "Цей сайт захищений reCAPTCHA та Google і застосовуються",
    signIn_privacyPolice: "Політика конфіденційності",
    signIn_and: "та",
    signIn_Terms: "Умови використання.",
    signIn_Login: "Увійти через {v1}",
    signIn_Register: "Реєстрація через {v1}",
    signIn_RegisterWithEmail: "Зареєструйтесь за допомогою електронної пошти",
    signIn_RegisterWithQuestion: "Далі: Про мій бізнес",
    signIn_SeparatorText: "АБО",
    signIn_TitleWithQuestion: "Зареєструйтесь у AirVote, щоб:",
    signIn_ChecklistFirst: "Отримати QR-смайлики електронною поштою",
    signIn_ChecklistSecond: "Отримати доступ до панелі бізнесу для відстеження відгуків",
    profilePosition: "Персонал",
    password_validation_min_length: "Мінімум 6 символів",
    password_validation_uppercase: "Одна велика літера",
    password_validation_lowercase: "Одна маленька літера",
    ambassadorBtn_title: 'Станьте амбасадором J-Bar',
    ambassadorBtn_subtitle: "Відгуки = Нагороди",
    ambassadorPopup_title: "Щоб стати амбасадором J-Bar, вам необхідно:",
    ambassadorPopup_votes: "20 AirVotes",
    ambassadorPopup_review: "Залиште відгук на будь-якій зі cторінок {v1}",
    giveawayPopup_entered: "Ви будите приймати участь в розіграші",
    ambassadorPopup_BtnLogin: "Почніть з входу в",
    giveawayPopup_BtnReview: 'Залиште відгук',
    ambassadorPopup_cancel: 'Ні дякую',
    ambassadorFinishTitle: "Переваги J-Bar Амбасадорів",
    ambassadorMonthlyDrawing: "Кожен AirVote голос бере участь в щомісячному розіграші 100 доларів США",
    ambassadorReceive: "Амбасадори отримають додаткові подарунки та визнання!",
    ambassadorHelpUsTogether: "Допоможіть нам досягти успіху разом!",
    giveawayPopup_finalStep: 'Ми вдячні за ваш чесний відгук!\n\nВас додали до нашого розіграшу.\n\nПовертайтеся і голосуйте ще раз: кожен голос збільшить ваші шанси!',
    giveawayPopup_proceedReview: "Перейти до відправки відгука",
    title_404: "Сторінка, на яку ви намагаєтесь потрапити, недоступна",
    btn_404: "Назад",
    Logout: "Вихід",
    Thank_for_vote: "Дякуємо за Ваш відгук. Бажаєте подивитися Ваші оцінки? Увійдіть за допомогою",
    writeFeedBack: "Залишити відгук (опціонально)",
    voteSuccessText_1: "Дякуємо! Ваш відгук надіслано!",
    voteSuccessText_2: "Бажаєте змінити відгук? Натисніть на інший смайлик.",
    voteSuccessText_3: "Є що сказати? Можете залишити коментар",
    Sync_status: "Статус синхронізації",
    Submit: "Надіслати коментар",
    Cancel: "Скасувати",
    feedbackTitle: "Залиште свій коментар",
    feedbackTitleSoSo: "Що треба покращити?",
    feedbackTextRating: 'Чому ви поставили цьому спікеру таку оцінку?',
    feedbackTitleSad: "Підкажіть, що не так?",
    yourNote: "Ваш коментар",
    addYourNote: "Додайте коментар",
    commentPopupEmail: "Введіть номер телефону або email",
    feedbackText: "Зв’яжіться зі мною",
    feedbackTextOr: "чи",
    feedbackTextServiceLog: "Контактні дані",
    writeAReview: "Публічний відгук",
    writeAReviewTitle: "Ви можете залишити відгук для {v1} тут:",
    Sent: "Надісланий",
    Close: "Закрити",
    OK: "OK",
    thankVoteTitle1: "Ваш відгук успішно збережено",
    thankVoteTitle2_1: "Дякуємо за ваш відгук",
    thankVoteTitle2_2: "Увійдіть в AirVote, щоб ви могли переглянути та змінити свої голоси",
    Email: "Email",
    reviewSocial: "Про нас",
    reviewSocialOr: "Більше про нас",
    anonComment: "Анонімний коментар",
    powered_by: "Powered by AirVote\nGet it for your business",
    UploadNewPhoto: "Завантажте нову фотографію",
    RemovePhoto: "Видалити фотографію",
    WrongFormat: "Неправильний формат. Підтримуються формати PNG та JPG",
    PhotoOverweight: "Фото більше ніж {v1}Мб",
    max_attach_photos_count_error: "Максимальна кількість файлів - {v1}",
    ambassadorDescription: "Кожен AirVote відгук додає вас в щомісячний розіграш 100 доларів США (обмеження 1 на кожне місце в день). \n "+
        "Амбасадор отримають додаткові нагороди і визнання! \n" +
        "\n" + "Допоможіть нам досягти успіху разом!",
    Placement: "Місцезнаходження",
    Update: "Оновити",
    NewPlacementSaved: "Нове місцезнаходження успішно збережено",
    PleaseEnterCorrectPlacement: "Будь ласка, введіть правильне місцезнаходження",
    QR_smiley_disabled: "Цей QR-смайлик не активний.\nБудь ласка, зверніться напряму до керівництва.",
    QR_smiley_disabled_links: "Маєте запитання про AirVote®?\nВідвідайте на вебсайт {v1} або напишіть нам за адресою {v2}.",
    QR_smiley_disabled_footer: "Дякуємо за наданий відгук!",
    manageGPSAllowTitle: "Не проти поділитися своїм місцезнаходженням?",
    manageGPSAllowText: "Знання точного місцезнаходження проблеми допомагає нам швидше її вирішити. Ми не будемо відстежувати ваше місцезнаходження та не повідомляти його нікому, крім нашої служби обслуговування",
    manageGPSAllowOKButton: "Добре, поділитися",
    manageGPSAllowCancelButton: 'Не ділиться',
    level2_notp: "Немає паперу",
    level2_full: "Заповнений",
    level2_dirty: "Брудно",
    level2_smells: "Смердить",
    level2_broken: "Зламано",
    level2_otherl: "Інше",
    level2_nopaper: "Немає рушників",
    level2_title: "Надані послуги",
    level2_maxCount: "Максимальна кількість для вибору: {v1}",
    need_audio_permission_error: "Будь ласка, надайте доступ до мікрофону для запису аудіо",
    play_dino: "Грати",
    dino_play_btn: "Грати",
    dino_jump_btn: "Стрибнути",
    dino_down_btn: "Присісти",
    vote_screen_public_review_popup_title: "Залиште відгук в соцмережах",
    sl_final_Title1: "Service log saved!",
    serviceLogInfoBtn: "Історія обслуговування",
    noServiceLogs: "Журнал обслуговування пустий",
    snapPicturePopupTitle: "Підтвердіть свій відгук фотографією вбиральні",
    snapPictureButton: "Сфотографувати",
    snapPicturePopupContinue: "Продовжити",
    subtitleDefault: "Будемо вдячні за відправлене фото проблеми",
    signIn_Pin: "Увійти через ПІН",
}
